import { useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loading from "../../../components/core/blocks/Loading";
import CurveCharts from "../charts/CurveCharts";
import { PricingProductUnavailable } from "../components/PricingProductUnavailable";

export const DemandChartsSection = ({ pricingProduct, isPricingProductDataLoading, pricingProductError, product }) => {
  const { t } = useTranslation(["pricingv2"]);
  let daysWithPrice = pricingProduct?.pricing_org?.days_with_price;
  if (daysWithPrice === undefined) {
    daysWithPrice = 1;
  }
  const needsProfiling =
    pricingProduct?.pricing_data?.filter((r) => r.num_days_at_price !== 0 && r.num_days_at_price >= daysWithPrice)
      .length < 3;

  const dataStatus = useMemo(() => {
    const status = {
      notEnoughData: false,
      generation: false,
      invalidStrategy: false,
    };

    if (!pricingProduct?.pricing_data) {
      status["generation"] = true;
      return status;
    }

    if (pricingProduct.pricing_data.length > 1) {
      let modelledSum = 0;

      for (let i = 0; i < pricingProduct.pricing_data.length; i++) {
        modelledSum += pricingProduct.pricing_data[i].modeled_demand;
      }

      if (modelledSum === 0) {
        status["notEnoughData"] = true;
        return status;
      }
    }

    return status;
  }, [pricingProduct]);

  if (isPricingProductDataLoading) {
    return <Loading height={"300px"} fullPage={false} />;
  }

  if (pricingProductError || !pricingProduct) {
    return <PricingProductUnavailable error={pricingProductError} />;
  }

  if (needsProfiling) {
    return (
      <Row>
        <Col className="text-center">
          <div className="fs-4 py-5">{t(($) => $.pricingv2["Not enough prices to generate demand curve."])}</div>
        </Col>
      </Row>
    );
  }

  return (
    <>
      {!dataStatus.notEnoughData && !dataStatus.generation && (
        <Row>
          <Col xs={12}>
            <CurveCharts optData={pricingProduct} price={product ? product.product_price : pricingProduct.best_price} />
          </Col>
        </Row>
      )}

      {dataStatus.notEnoughData && (
        <Row className="text-center py-5">
          <Col xs={12}>
            <p className="fs-4">
              <strong>
                {t(
                  ($) =>
                    $.pricingv2["Not enough price changes over the last 365 days to show the pricing the demand trend"],
                )}
              </strong>
            </p>
          </Col>
        </Row>
      )}

      {dataStatus.generation && (
        <Row className="text-center py-5">
          <Col xs={12}>
            <p className="fs-4">
              <strong>
                {t(($) => $.pricingv2["The pricing trend is being generated. Please check back in a few hours."])}
              </strong>
            </p>
          </Col>
        </Row>
      )}
    </>
  );
};
